import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {khanmigoToolsCreateBlooketV2Type} from "./__graphql-types__/index.ts";

export const CREATE_BLOOKET_MUTATION_V2: GqlOperation<
    khanmigoToolsCreateBlooketV2Type["response"],
    khanmigoToolsCreateBlooketV2Type["variables"]
> = gqlOp(gql`
    mutation khanmigoToolsCreateBlooketV2($input: BlooketQuestionSetInput!) {
        createBlooketQuestionSetV2(input: $input) {
            error {
                code
            }
        }
    }
`);
